import AutoDeliveryModal from './AutoDeliveryModal';

export default AutoDeliveryModal;
